import { render, staticRenderFns } from "./ServiceSystemForm.vue?vue&type=template&id=bc90dce6&scoped=true&"
import script from "./ServiceSystemForm.vue?vue&type=script&lang=js&"
export * from "./ServiceSystemForm.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSystemForm.vue?vue&type=style&index=0&id=bc90dce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc90dce6",
  null
  
)

export default component.exports